// Navigation helper to avoid full page reloads
let navigate = null;

export const setNavigate = (navigateFunction) => {
  navigate = navigateFunction;
};

export const navigateToLogin = (mode = 'SESSION_EXPIRED') => {
  if (navigate) {
    navigate('/login', { state: { mode }, replace: true });
  } else {
    // Fallback to window.location if navigate is not available
    window.location.href = `/login?mode=${mode}`;
  }
};

export const navigateToPath = (path, options = {}) => {
  if (navigate) {
    navigate(path, options);
  } else {
    window.location.href = path;
  }
};
